import React, { useEffect, useState } from 'react'
import { useAppInfo } from 'AppState'
import PieChartCategory from 'components/Charts/PieChartCategory'
import CashflowChart from '../Cashflow/CashflowChart'
import AmortizationTable from './AmortizationTable'
import LiabilityPaybackSummary from './LiabilityPaybackSummary'
import TableGen from 'components/Table/TableGen'
import { getSpecificArrayObjKeys } from "utils/utilGeneral"
import LiabilityManageSteps from './LiabilityManageSteps'
import LiabilityOverview from './LiabilityOverview'
import NoFinancialData from 'myFinancials/Template/NoFinancialData'
import LiabilityPayback from './LiabilityPayback'


export default function LiabilityInfo({info,displayType="tabs"}) {
  const {stateMyFinancials} = useAppInfo()
  const {liabilities,cashflowDistribution,financialsLoaded} = stateMyFinancials
  const {liabilityDist} = cashflowDistribution
  const [tabIndex,setTabIndex]  = useState(0)
  const tabList = ["Overview","Steps to manage Liabilities","Payment Overview","Allocation","Projections","Amortization Schedule"]

  useEffect(()=>{
    if (info && displayType !== "tabs"){
      setTabIndex(tabList.indexOf(info))
    }
  },[info])

  const [cashflowData,setCashflowData] = useState([])

  useEffect(()=>{
    if (liabilityDist){
    
     setCashflowData(liabilityDist)
    }
  },[liabilityDist])


  const tabContent = {
    "Overview": <LiabilityOverview/>,
    "Steps to manage Liabilities":<LiabilityManageSteps/>,
    "Payment Overview":<LiabilityPaybackSummary/>,
    "Allocation":
    <div style={{display:"flex",flexDirection:"column"}}>
    <div style={{width:"100%",height:"400px"}}>  
    <PieChartCategory weightType='weighted' weightCategory={"amount"} data={liabilities} category={"name"}/>
    </div>
    {liabilities.length > 0 && 
    <div>
    <TableGen data={getSpecificArrayObjKeys(liabilities,["type","name","currentAllocation"])}/></div>}
    </div>,
    "Projections":<CashflowChart data={cashflowData}/>,
    "Amortization Schedule": <AmortizationTable/>,
    "Payback Details": <LiabilityPayback/>
  }

  if (financialsLoaded && liabilities.length === 0){
    return (
      <div style={{width:"100%",height:"100%",position:"relative",minHeight:"50vh"}}>
       <NoFinancialData financialType='liabilities'/>
      </div>
    )
  }

  return (
    <div style={{width:"100%",height:"100%",position:"relative"}}>
     
    {(financialsLoaded && liabilities.length > 0) && tabContent[info]}

    </div>
  )
}

